import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { FeatureNotEnabledView } from '@euler/components/entitlements/FeatureNotEnabledView';
import { useStoreFeature } from '@euler/functions/entitlements/useStoreFeature';
import { useUserProfileInfo } from '@euler/functions/user/useUserProfileInfo';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { StoreFeature } from '@euler/model/enum';
import { useMemo } from 'react';
import { Text } from 'react-native';
import { BiCardDetailView } from './card/BiCardDetailView';
import {
  biDateChoiceOfParam,
  biDateChoiceParam,
} from './dashboard/functions/biDateRange';

export interface BiCardPageParams {
  dashboardId: string;
  cardId: string;
  /** The date range, as the dashboard passed it; see `biDateChoiceParam`. */
  range?: string;
}

function BiCard({ dashboardId, cardId, range }: BiCardPageParams) {
  const navigation = useAppNavigation();
  const choice = useMemo(() => biDateChoiceOfParam(range), [range]);
  return (
    <BiCardDetailView
      dashboardId={dashboardId}
      cardId={cardId}
      choice={choice}
      onChoice={next =>
        navigation.setParams({ range: biDateChoiceParam(next) })
      }
      onBack={() => navigation.goBack()}
    />
  );
}

export const BiCardPage = wrapNavigatorScreen(
  ({ dashboardId, cardId, range }: BiCardPageParams) => {
    const profile = useUserProfileInfo();
    const bi = useStoreFeature(StoreFeature.Bi);
    if (!bi.enabled) return <FeatureNotEnabledView feature={StoreFeature.Bi} />;
    if (!profile?.user.enabled)
      return <Text>当前门店尚未开通经营分析，或账号不可用。</Text>;
    return (
      <BiCard
        key={`${profile.org.id}:${profile.store.id}:${dashboardId}:${cardId}`}
        dashboardId={dashboardId}
        cardId={cardId}
        range={range}
      />
    );
  },
  { title: '图表', headerShown: false, headerMode: 'float' },
);
